import { useState } from 'react';
import { buildWhatsAppUrl, buildXUrl, copyToClipboard, tryShare } from '../../utils/share';

type ShareLinksProps = {
  url: string;
  title: string;
  text?: string;
};

export function ShareLinks({ url, title, text }: ShareLinksProps) {
  const [feedback, setFeedback] = useState<string | null>(null);

  async function handleNativeShare() {
    const ok = await tryShare({ url, title, text });
    if (ok) {
      setFeedback('Compartilhado ✓');
      window.setTimeout(() => setFeedback(null), 1500);
    }
  }

  async function handleCopy() {
    const ok = await copyToClipboard(url);
    if (ok) {
      setFeedback('Link copiado ✓');
      window.setTimeout(() => setFeedback(null), 1800);
    }
  }

  const linkClass =
    'inline-flex items-center justify-center gap-2 rounded-md border border-gold/40 px-4 py-2 font-mono text-xs uppercase tracking-stamp text-champagne transition-colors duration-fast hover:border-gold hover:text-gold';

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex flex-wrap items-center justify-center gap-2">
        <button
          type="button"
          onClick={handleNativeShare}
          className={linkClass}
          aria-label="Compartilhar via menu do dispositivo"
        >
          <svg
            viewBox="0 0 24 24"
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="18" cy="5" r="3" />
            <circle cx="6" cy="12" r="3" />
            <circle cx="18" cy="19" r="3" />
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
          </svg>
          Compartilhar
        </button>

        <a
          href={buildWhatsAppUrl(text ?? title, url)}
          target="_blank"
          rel="noreferrer noopener"
          className={linkClass}
          aria-label="Compartilhar no WhatsApp"
        >
          WhatsApp
        </a>

        <a
          href={buildXUrl(text ?? title, url)}
          target="_blank"
          rel="noreferrer noopener"
          className={linkClass}
          aria-label="Compartilhar no X (Twitter)"
        >
          X
        </a>

        <button
          type="button"
          onClick={handleCopy}
          className={linkClass}
          aria-label="Copiar link"
        >
          Copiar link
        </button>
      </div>

      <div className="h-4">
        {feedback ? (
          <p role="status" aria-live="polite" className="font-mono text-[10px] uppercase tracking-stamp text-gold">
            {feedback}
          </p>
        ) : null}
      </div>
    </div>
  );
}
